const getNeedlePieDataFields = () => {
  return [
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Range Colors",
      type: "CONDITIONAL_FORMATTING",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "conditionalFormatting",
      itemInArray: true,
      defaultValue: [],
    },
  ];
};

export { getNeedlePieDataFields };

const getNeedlePieCustomizationField = () => {
  return [
    {
      title: "Outer Radius",
      type: "range",
      defaultValue: 100,
      minValue: 100,
      maxValue: 265,
      reduxKey: "outerRadius",
    },
    {
      title: "Padding Angle",
      type: "range",
      defaultValue: 0,
      minValue: 0,
      maxValue: 40,
      reduxKey: "paddingAngle",
    },
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },
            { label: "Middle", value: "middle" },
            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "bottom" },
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
        },
      ],
    },
  ];
};

export { getNeedlePieCustomizationField };
